/*=========================================================================================
  File Name: index.js
  Namespace: categories
  Description: Vuex Category Store
==========================================================================================*/

import {
  listCategories,
  getCategory
} from '@/services/categories.service.js'

const state = {
  categoryList: {},
  count: 0,
  next: null,
  previous: null,
  results: []
}

const getters = {
  getCategories(state) {
    return Object.entries(state.categoryList).map(([key, value]) => {
      return {
        label: value.name.charAt(0).toUpperCase() + value.name.slice(1),
        value: key
      }
    })
  },
  getCategoriesEntries(state) {
    return state.categoryList
  }
}

const mutations = {
  STORE_CATEGORY_LIST(state, categories) {
    state.categoryList = {
      ...state.categoryList,
      ...categories.entries
    }
    state.count = categories.count
    state.next = categories.next
    state.previous = categories.previous
    categories.results ? state.results = [...state.results, ...categories.results] : null
  },
  RESET_CATEGORIES(state) {
    state.categoryList = {}
  }
}

const actions = {
  async getCategory({
    commit
  }, categoryId) {
    const response = await getCategory({
      categoryId: categoryId
    })
    if (response) {
      commit('STORE_CATEGORY_LIST', response)
    }
    return response
  },
  async getAllCategories({
    commit, rootState
  }, params = {}) {
    params.company = rootState.app.company
    params.page_size = 256
    const response = await listCategories(params)
    if (response) {
      commit('STORE_CATEGORY_LIST', response)
    }
    return response
  },
  resetCurrentCategories({
    commit
  }) {
    commit('RESET_CATEGORIES')
  }
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}